import React from 'react';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import {
  useApiClient,
  useFetchImmutable,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import CardView from './incoming-card-view';
import { useAuthStore } from '../../../../store';
import useIsAdmin from '../../../../hooks/use-is-admin';

type CardContainerProps = {
  tripRequest: TripRequest;
};

const CardContainer = ({
  tripRequest,
}: CardContainerProps) => {
  const apiClient = useApiClient();
  const { loggedInTeamMember } = useAuthStore();
  const isAdmin = useIsAdmin();

  const {
    data: countryCodes,
  } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  return (
    <CardView
      countryCodes={countryCodes}
      tripRequest={tripRequest}
      loggedInTeamMember={loggedInTeamMember}
      isAdmin={isAdmin}
    />
  );
};

export default CardContainer;
